import {
    animateNumber,
    applyTemplate, cancelDeletionOfAccount, changeDefaultLanguage, checkUncheckAll, clearColorPicker,
    closeSnackbar, crosshairHover, dateFormat, dragAndScrollPlanner,
    drawChartForPlanner, drawChartsForAnalytics, formsSync, fullscreenEventListener,
    goToTop, moveDown, moveToBottom, moveToTop, moveUp, prepareSelectedItems,
    renderFormDependsOnFrequencyType, reorderTemplates, reRenderCategories, sanitizeAmountInput,
    searchInActivate, selectAllPills, showSnackbar, switchingTabs, toggleEye, toggleFullscreen,
    toggleMonthStatus, togglePillBox, togglePlannerCards, togglePrivacyMode, toggleQuickMenu,
    toggleTheme
} from "./libraries/Utils.js";
import Shortcuts from "./libraries/Shortcuts.js";
import Dropdown from "./libraries/Dropdown.js";
import Actions from "./libraries/Actions.js";
import Tooltip from "./libraries/Tooltip.js";
import ModalActions from "./libraries/ModalActions.js";
import Animations from "./libraries/Animations.js";
import LoadMoreActions from "./libraries/LoadMoreActions.js";
import Chips from "./libraries/Chips.js";
import ActionBars from "./libraries/ActionBars.js";
import Tutorial from "./libraries/Tutorial.js";
import './components/index.js';

(() => {
    "use strict";

    window.addEventListener('offline', () => {
        const offline = document.querySelector('.offline');

        if (offline) {
            offline.classList.add('show');
        }
    });

    window.addEventListener('online', () => {
        const offline = document.querySelector('.offline');

        if (offline) {
            offline.classList.remove('show');
        }
    });

    const ready = (callback) => {
        if (document.readyState !== 'loading') {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    };

    ready(() => {
        const tutorial = new Tutorial();
        const actions = new Actions();
        const loadMoreActions = new LoadMoreActions();
        formsSync();

        const snackbarMessage = localStorage.getItem('bsense_snackbar');

        if (snackbarMessage) {
            let {message, type, translateAfter} = JSON.parse(snackbarMessage);
            showSnackbar(translateAfter ? __(message) : message, type);
            localStorage.removeItem('bsense_snackbar');
        }

        // fullscreenEventListener();
        (new Shortcuts());
        (new Dropdown());
        (new Tooltip());
        (new ModalActions());
        (new Animations());
        (new Chips());
        (new ActionBars());

        setTimeout(() => {
            if (typeof RUN_INTRO !== 'undefined' && RUN_INTRO) {
                tutorial.play();
            }
        }, 1000);

        document.querySelector('main')?.addEventListener('scroll', e => {
            const dropdown = document.querySelector('.dropdown.dropdown--active');

            if (dropdown && !dropdown.classList.contains('dropdown--searchbar-focused') && !dropdown.classList.contains('dropdown--prevent-auto-scroll-closing')) {
                const vHeight = window.innerHeight || document.documentElement.clientHeight;
                const vWidth = window.innerWidth || document.documentElement.clientWidth;

                const targetElement = dropdown.querySelector('.dropdown__content') || dropdown;
                const targetRect = targetElement.getBoundingClientRect();

                const isFullyVisible =
                    targetRect.top >= 0 &&
                    targetRect.left >= 0 &&
                    Math.floor(targetRect.bottom) <= vHeight &&
                    Math.floor(targetRect.right) <= vWidth;

                if (isFullyVisible) {
                    dropdown.classList.remove('dropdown--active');

                    if (dropdown.classList.contains('dropdown--searchbar')) {
                        dropdown.querySelector('.dropdown__searchbar input').value = null;
                        dropdown.querySelectorAll('.dropdown__item').forEach(item => item.classList.remove('dropdown__item--hide'));
                    }

                    setTimeout(() => dropdown.querySelector('.dropdown__content').scrollTop = 0, 200);
                } else {
                    dropdown.classList.add('dropdown--prevent-auto-scroll-closing');
                }
            }
        });

        if (document.querySelector('[data-datepicker]')) {
            const daysShort = Object.keys(SYSTEM_I18N.common).filter(key => key.startsWith('day_short_')).map(key => SYSTEM_I18N.common[key]);
            const daysLong = Object.keys(SYSTEM_I18N.common).filter(key => key.startsWith('day_') && !key.includes('short')).map(key => SYSTEM_I18N.common[key]);

            const makeSundayFirst = (list) => {
                if (list.length === 7) {
                    list.unshift(list.pop());
                }

                return list;
            };

            const flatpickrDaysShort = makeSundayFirst([...daysShort]);
            const flatpickrDaysLong  = makeSundayFirst([...daysLong]);
            const flatpickrMonthsShort = Object.keys(SYSTEM_I18N.common).filter(key => key.startsWith('month_short_')).map(key => SYSTEM_I18N.common[key]);
            const flatpickrMonthsLong = Object.keys(SYSTEM_I18N.common).filter(key => key.startsWith('month_') && !key.includes('short')).map(key => SYSTEM_I18N.common[key]);
            const customI18n = {
                firstDayOfWeek: USER['week_start'] === 'Monday' ? 1 : 0,
                weekdays: {
                    shorthand: flatpickrDaysShort,
                    longhand: flatpickrDaysLong
                },
                months: {
                    shorthand: flatpickrMonthsShort,
                    longhand: flatpickrMonthsLong
                }
            };

            const customFormatDateCallback = (config) => {
                return (date, formatStr) => {
                    if (formatStr === 'custom') {
                        if (config.dateFormat !== 'H:i') {
                            const unixTimestamp = Math.floor(date.getTime() / 1000);
                            return dateFormat(unixTimestamp, !config.enableTime);
                        } else {
                            const hours = String(date.getHours()).padStart(2, '0');
                            const minutes = String(date.getMinutes()).padStart(2, '0');
                            return `${hours}:${minutes}`;
                        }
                    }

                    return flatpickr.formatDate(date, formatStr);
                }
            }

            window.DEFAULT_PICKER_CONFIG = {
                dateFormat: 'Y-m-d',
                time_24hr: true,
                disableMobile: true,
                locale: customI18n,
                altInput: true,
                altFormat: 'custom'
            };

            window.applyPicker = (target, modeOptions = {}, initialValue = null) => {
                if (target) {

                    target.setAttribute('type', 'text');
                    target.value = '';

                    if (target._flatpickr) {
                        target._flatpickr.destroy();
                    }

                    const mergeOptions = {...window.DEFAULT_PICKER_CONFIG, ...modeOptions};

                    mergeOptions.formatDate = customFormatDateCallback(mergeOptions);

                    if (initialValue) {
                        mergeOptions.defaultDate = initialValue;
                    }

                    return flatpickr(target, mergeOptions);
                }
            };

            document.querySelectorAll('[data-datepicker]').forEach(target => {
                let picker = target._flatpickr;

                if (!picker) {
                    const isDateTime = 'datetime' in target.dataset;
                    const isTimeOnly = 'time' in target.dataset;
                    const hasMinDate = 'mindate' in target.dataset;
                    const hasMaxDate = 'maxdate' in target.dataset;

                    window.applyPicker(target, {
                        enableTime: isDateTime || isTimeOnly,
                        noCalendar: isTimeOnly,
                        dateFormat: isTimeOnly ? 'H:i' : (isDateTime ? 'Y-m-d H:i' : 'Y-m-d'),
                        minDate: (hasMinDate ? target.dataset.mindate : null),
                        maxDate: (hasMaxDate ? target.dataset.maxdate : null)
                    }, target.value || null);
                }
            });
        }

        document.addEventListener('click', e => {
            const target = e.target;

            if (document.querySelector('aside')) {
                if (!target.closest('aside') && document.querySelector('aside').classList.contains('aside--visible')) {
                    document.querySelector('aside').classList.remove('aside--visible');

                    if (BS_EVENTS.was_quick_menu_visible) {
                        document.getElementById('quick-menu').classList.add('show');
                        delete BS_EVENTS.was_quick_menu_visible;
                    }
                }
            }

            if (target.closest('#play-tutorial')) {
                tutorial.play();
            }

            if (target.closest('#sign-in-btn')) {
                actions.signIn();
            }

            if (target.closest('#demo-btn')) {
                actions.demoSignIn();
            }

            if (target.closest('#sign-up-btn')) {
                actions.signUp();
            }

            if (target.closest('#update-password-btn')) {
                actions.setNewPassword();
            }

            if (target.closest('#send-reset-link-btn')) {
                actions.sendResetLink();
            }

            if (
                target.closest('input[type="time"]') ||
                target.closest('input[type="datetime-local"]')
            ) {
                target.showPicker?.();
            }

            if (target.matches('#edit-space')) {
                actions.editSpace();
            }

            if (target.matches('#update-account-settings')) {
                actions.updateAccountSettings();
            }

            if (target.matches('#update-security-change-password')) {
                actions.changePassword();
            }

            if (target.matches('#transaction-save')) {
                actions.transactionSave();
            }

            if (target.matches('#template-save')) {
                actions.transactionTemplateSave();
            }

            if (target.matches('#template-update')) {
                actions.transactionTemplateEdit();
            }

            if (target.matches('#transaction-update')) {
                actions.transactionEdit();
            }

            if (target.matches('#resend-verification')) {
                actions.resendVerificationEmail(target);
            }

            if (target.matches('#run-scanner')) {
                actions.scanner();
            }

            if (target.matches('.select-all')) {
                selectAllPills(target);
            }

            if (target.matches('#scheduled-transaction-save')) {
                actions.scheduledTransactionSave();
            }

            if (target.matches('#scheduled-transaction-update')) {
                actions.scheduledTransactionEdit();
            }

            if (target.matches('#transaction-toggle-approved')) {
                actions.toggleTransactionStatus(target);
            }

            if (target.matches('#scheduled-transaction-toggle-active')) {
                actions.toggleScheduledTransactionActive(target);
            }

            if (target.matches('#scheduled-transaction-toggle-auto-approve')) {
                actions.toggleScheduledTransactionAutoApprove(target);
            }

            if (target.matches('#submit-feedback')) {
                actions.submitFeedback(target);
            }

            if (target.matches('#submit-support')) {
                actions.submitSupport(target);
            }

            // @TODO all functions with api calls should be moved to actions

            if (target.closest('#fullscreen')) {
                toggleFullscreen(target.closest('.card__box'));
            }

            if (target.closest('#to-top')) {
                goToTop();
            }

            if (target.closest('#snackbar .icon--remove')) {
                closeSnackbar();
            }

            if (target.closest('.pill-box')) {
                togglePillBox(target);
            }

            if (target.closest('.feature-pages-categories-yearly_planner') && target.closest('.container') && target.closest('.toggle')) {
                toggleMonthStatus(target);
            }

            if (target.matches('.icon.theme')) {
                toggleTheme();
            }

            if (target.closest('.dropdown__item') && target.closest('.frequency_type')) {
                renderFormDependsOnFrequencyType(target);
            }

            if (target.closest('.planner-card') && !target.closest('.planner-card__content')) {
                togglePlannerCards(target.closest('.planner-card'));
            }

            if (target.closest('.dropdown__item') && target.closest('.form__group.type')) {
                reRenderCategories(target);
            }

            if (target.closest('.dropdown__item') && target.closest('.form__group.space')) {
                reRenderCategories(target, target.closest('.dropdown__item').dataset.value);
            }

            if (target.closest('.feature-pages-transactiontemplates-templates') && target.closest('.table-container') && target.closest('.dropdown__item:not(.dropdown__item--searchbar)')) {
                reorderTemplates(target);
            }

            if (target.closest('.privacy-mode-toggle')) {
                togglePrivacyMode(target);
            }

            if (target.closest('.checkbox') && target.closest('.grid__header') && target.closest('.feature-pages-scanner')) {
                checkUncheckAll(target);
            }

            if (target.closest('.checkbox') && target.closest('.grid__content') && target.closest('.feature-pages-scanner')) {
                prepareSelectedItems();
            }

            if (target.matches('#update-security-cancel-deletion-account')) {
                cancelDeletionOfAccount(target);
            }

            if (target.closest('.search-in') && (target.matches('button') || target.matches('.icon'))) {
                searchInActivate(target);
            }

            if (target.closest('.color__picker') && target.closest('button#clear-color-picker')) {
                clearColorPicker(target);
            }

            if (target.closest('.end_of_month')) {
                if (target.closest('.end_of_month').querySelector('input:checked')) {
                    target.closest('form').querySelector('.due_day').classList.add('disabled-element');
                } else {
                    target.closest('form').querySelector('.due_day').classList.remove('disabled-element');
                }
            }

            if (target.closest('.dropdown__item:not(.dropdown__item--header)') && target.closest('.template')) {
                applyTemplate(target);
            }

            if (target.closest('.card__info--tabs') && target.closest('.tab')) {
                switchingTabs(target);
            }

            /**
             * Category builder menu options
             */

            if (target.closest('.move-up')) {
                moveUp(target.closest('.placeholder__row'));
            }

            if (target.closest('.move-down')) {
                moveDown(target.closest('.placeholder__row'));
            }

            if (target.closest('.move-to-top')) {
                moveToTop(target.closest('.placeholder__row'));
            }

            if (target.closest('.move-to-bottom')) {
                moveToBottom(target.closest('.placeholder__row'));
            }

            if (target.closest('.dropdown__item') && target.closest('.aside__footer')) {
                changeDefaultLanguage(target);
            }

            if (target.matches('.icon--menu')) {
                document.querySelector('aside').classList.add('aside--visible');

                BS_EVENTS.was_quick_menu_visible = document.getElementById('quick-menu').classList.contains('show');

                if (BS_EVENTS.was_quick_menu_visible) {
                    document.getElementById('quick-menu').classList.remove('show');
                }
            }

            if (target.closest('[data-href]')) {
                const hrefEl = target.closest('[data-href]');

                if ('newTab' in hrefEl.dataset) {
                    window.open(hrefEl.dataset.href, '_blank');
                } else {
                    window.location.href = hrefEl.dataset.href;
                }

                return;
            }

            if (target.closest('.toggle-eye')) {
                toggleEye(target);
            }

            const card = target.closest('.card__box--collapsible');

            if (card && target.closest('.card__header')) {
                const content = card.querySelector(':scope > .card__content');

                content.style.scrollbarWidth = 'none';
                /** **/
                content.ontransitionend = e => {
                    if (e.target !== content || e.propertyName !== 'max-height') {
                        return;
                    }

                    content.style.removeProperty('scrollbar-width');
                    content.ontransitionend = null;
                };

                card.classList.toggle('card__box--opened');
            }
        });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.querySelector('.calendar .calendar__day--today')?.scrollIntoView({
                    block: 'nearest',
                    behavior: 'smooth'
                });
            });
        });

        toggleQuickMenu();

        // document.addEventListener('form:validated', e => {
        //     const {target,signal} = e.detail ;
        //     formsSync(target, signal);
        // });

        const loadMoreButton = document.querySelector('.button--load-more');

        if (loadMoreButton) {
            const loadMoreOptions = {
                root: document.querySelector('main'),
                rootMargin: '400px',
                threshold: 0
            };

            const loadMoreObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadMoreActions[loadMoreButton.dataset.callback](loadMoreButton, loadMoreButton.dataset.offset, loadMoreButton.dataset.limit);
                    }
                });
            }, loadMoreOptions);

            loadMoreObserver.observe(loadMoreButton);
        }

        document.addEventListener('input', e => {
           if (e.target && (e.target.matches('#amount') || e.target.matches('#budget'))) {
               e.target.value = sanitizeAmountInput(e.target.value);
           }

           if ((e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') && e.target.hasAttribute('maxlength')) {
               const label = e.target.closest('.form__group').querySelector('label');

               if (!label.querySelector('span')) {
                   label.insertAdjacentHTML('beforeend', '<span class="maxlength"><span>' + e.target.value.trim().length + '</span>/<span>' + e.target.maxLength + '</span></span>');
               } else {
                   label.querySelector('.maxlength span:first-child').textContent = e.target.value.trim().length;
               }
           }

           if (e.target.matches('#color-picker')) {
               const colorPicker = e.target.closest('.color__picker');
               const colorPickerField = colorPicker.querySelector('#color');
               const colorPickerCircle = colorPicker.querySelector('#color-circle');

               colorPickerCircle.style.backgroundColor = e.target.value;
               colorPickerCircle.classList.remove('chromatic-bloom');
               colorPickerField.value = e.target.value;
               colorPickerField.dispatchEvent(new Event('input', { bubbles: true }));
           }

            if (e.target.matches('#faq_search')) {
                const query = e.target.value.toLowerCase().trim();
                let hasMatches = false;

                document.querySelectorAll('.card__box--faq').forEach(section => {
                    let sectionHasMatches = false;

                    section.querySelectorAll(':scope > .card__content > .card__box').forEach(card => {
                            const matches = card.textContent.toLowerCase().includes(query);

                            card.classList.toggle('hide-element', !matches);

                            if (matches) {
                                sectionHasMatches = true;
                            }
                    });

                    section.classList.toggle('hide-element', !sectionHasMatches);

                    if (sectionHasMatches) {
                        hasMatches = true;
                    }
                });

                document.querySelector('.no-match').classList.toggle('hide-element', hasMatches);
            }
        });

        document.querySelectorAll('.number_animation').forEach(el => {
            animateNumber(el, 1000);
        });

        const actionBar = document.querySelector('.action__bar');

        if (actionBar) {
            const actionBarObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    const height = entry.borderBoxSize[0].blockSize;

                    document.documentElement.style.setProperty('--action-bar-dynamic-height', `${height}px`);

                    if (height > 100) {
                        document.querySelector('main .container').classList.add('calendar-no-sticky-action-bar');
                    } else {
                        document.querySelector('main .container').classList.remove('calendar-no-sticky-action-bar');
                    }
                }
            });

            actionBarObserver.observe(actionBar);
        }

        if (document.body.classList.contains('feature-pages-categories-yearly_planner')) {
            dragAndScrollPlanner();
            crosshairHover();
            drawChartForPlanner();
        }

        if (document.body.classList.contains('feature-pages-analytics')) {
            drawChartsForAnalytics();
        }
    });
})();